﻿import React, {FC} from 'react';
import {SelectProps} from "@mui/material";
import SearchFilterSelectChipList from "./SearchFilterSelectChipList";
import {SearchFilterDropDown, SearchFilterSearchChipMultiSelectRenderDiv} from "../styles";

// Component for creating a list of Chips as the selected values
// Note: This has potential to be refactored further to be less specific to SearchFilter
const SearchFilterChipMultiSelect: FC<SelectProps<Array<string>>> = ({children, ...rest}) => {

  const getRenderValue = (selected: any) => {
      if (selected.length === 1 ) {
        return (<SearchFilterSelectChipList selected={selected} />)
      } else {
        return (
          <SearchFilterSearchChipMultiSelectRenderDiv>
            {`${selected.length} selected`}
          </SearchFilterSearchChipMultiSelectRenderDiv>
        )}
      }

  return <SearchFilterDropDown
    size='small'
    multiple
    renderValue={getRenderValue}
    {...rest}
  >
    {children}
  </SearchFilterDropDown>
}

export default SearchFilterChipMultiSelect;
